module.exports = __webpack_public_path__ + "public/img/peizhi.8fbe8417.png";